/**
 * AWS Amplify configuration for Cognito authentication
 * Values loaded from environment variables
 */

import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
      },
    },
  });
};
